webpackJsonp([1],{

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(459),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_progressbar__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_gtm__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_gtm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_head__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(172);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_progressbar___default.a, {
  transition: {
    speed: '0.6s',
    opacity: '0.3s',
    termination: 200
  },
  autoRevert: true,
  color: 'rgb(0, 0, 0)',
  failedColor: 'red',
  height: '3px'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_gtm___default.a, {
  debug: false, // Whether or not display console logs debugs (optional)
  vueRouter: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */] // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'], // If router, you can exclude some routes name
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: 'UA-106049798-1',
  router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('colorize', {
  bind: function bind(el, binding) {
    var elm = el;
    elm.style.color = binding.value;
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('padToTwo', function (value) {
  var pad = void 0;
  if (value < 10) {
    pad = '0' + value;
  } else {
    pad = value;
  }
  return pad;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('getAmount', function (value) {
  var amount = '';
  amount = value.toString().split('.');
  return amount[0];
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('getCents', function (value) {
  var amount = '';
  amount = value.toString().split('.');
  if (amount[1] === '' || amount[1] == null) {
    amount = '00';
  } else {
    amount = amount[1];
  }
  return amount;
});

/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */]),
  router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_9__App___default.a },
  data: function data() {
    return {
      basket: {
        products: []
      },
      looks: {
        men: {
          1: {
            name: 'Look 1',
            hex_color: '#9296a3',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/1/slide.jpg',
              large: 'static/img/looks/men/1/large.jpg',
              platter: 'static/img/looks/men/1/platter.jpg',
              scenes: ['static/img/looks/men/1/scene_1.jpg', 'static/img/looks/men/1/scene_2.jpg']
            },
            clothings: {
              top: ['RUN WARM+ VESTE GRIS', 'RUN DRY+ T SHIRT NOIR CHINE'],
              bottom: ['RUN WARM+ PANT NOIR'],
              shoes: ['RUN ACTIVE BLEU JAUNE'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES']
            },
            references: [8395488, 8381934, 8394834, 8379979, 8325547]
          },
          2: {
            name: 'Look 2',
            hex_color: '#dcf78c',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/2/slide.jpg',
              large: 'static/img/looks/men/2/large.jpg',
              platter: 'static/img/looks/men/2/platter.jpg',
              scenes: ['static/img/looks/men/2/scene_1.jpg', 'static/img/looks/men/2/scene_2.jpg']
            },
            clothings: {
              top: ['RUN WARM+ VESTE SANS MANCHE NOIR', 'RUN WARM+ MML JAUNE'],
              bottom: ['RUN DRY+ SHORT BY NIGHT', 'RUN DRY+ COLLANT PRINT'],
              shoes: ['RUN ACTIVE NOIR GRIS'],
              accessories: ['RUN LIGHT 250 GREY', 'BANDEAU BY NIGHT']
            },
            references: [8394831, 8394839, 8381795, 8394756, 8379985, 8369001, 8369000]
          },
          3: {
            name: 'Look 3',
            hex_color: '#f05A3C',
            price: 79.99,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/3/slide.jpg',
              large: 'static/img/looks/men/3/large.jpg',
              platter: 'static/img/looks/men/3/platter.jpg',
              scenes: ['static/img/looks/men/3/scene_1.jpg', 'static/img/looks/men/3/scene_2.jpg']
            },
            clothings: {
              top: ['RUN WARM+ VESTE ROUGE', 'RUN DRY+ T SHIRT ROUGE'],
              bottom: ['RUN WARM+ PANT GRIS'],
              shoes: ['RUN ACTIVE GRIS ROUGE'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES']
            },
            references: [8395487, 8381800, 8394835, 8379976, 8325547]
          },
          4: {
            name: 'Look 4',
            hex_color: '#dce1e7',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/4/slide.jpg',
              large: 'static/img/looks/men/4/large.jpg',
              platter: 'static/img/looks/men/4/platter.jpg',
              scenes: ['static/img/looks/men/4/scene_1.jpg', 'static/img/looks/men/4/scene_2.jpg']
            },
            clothings: {
              top: ['RUN WARM+ VESTE BY NIGHT', 'RUN DRY+ TSHIRT  NOIR CHINE'],
              bottom: ['RUN WARM+ COLLANT NOIR JAUNE'],
              shoes: ['RUN ELIORUN NOIR'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES', 'SGN 400']
            },
            references: [8394841, 8381934, 8394843, 8379984, 8325547, 8394633]
          },
          5: {
            name: 'Look 5',
            hex_color: '#000000',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/5/slide.jpg',
              large: 'static/img/looks/men/5/large.jpg',
              platter: 'static/img/looks/men/5/platter.jpg',
              scenes: ['static/img/looks/men/5/scene_1.jpg', 'static/img/looks/men/5/scene_2.jpg']
            },
            clothings: {
              top: ['RUN WARM+ VESTE NOIR', 'RUN WARM+ MML NOIR CHINE'],
              bottom: ['RUN DRY + SHORT NOIR', 'RUN WARM+ COLLANT NOIR'],
              shoes: ['RUN ACTIVE NOIR GRIS'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES']
            },
            references: [8395486, 8394838, 8381935, 8394833, 8379985, 8325547]
          },
          6: {
            name: 'Look 6',
            hex_color: '#9296a3',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/6/slide.jpg',
              large: 'static/img/looks/men/6/large.jpg',
              platter: 'static/img/looks/men/6/platter.jpg',
              scenes: ['static/img/looks/men/6/scene_1.jpg', 'static/img/looks/men/6/scene_2.jpg']
            },
            clothings: {
              top: ['RUN RAIN VESTE NIGHT', 'RUN WARM+ MML GRIS'],
              bottom: ['RUN DRY+ SHORT NOIR', 'RUN WARM+  COLLANT NOIR'],
              shoes: ['RUN ELIOPRIME VERT'],
              accessories: ['EVOLUTIVE GLOVE BY NIGHT CHINE']
            },
            references: [8394761, 8394837, 8381935, 8394833, 8379988, 8393526, 8394633]
          },
          7: {
            name: 'Look 7',
            hex_color: '#dcf78c',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/7/slide.jpg',
              large: 'static/img/looks/men/7/large.jpg',
              platter: 'static/img/looks/men/7/platter.jpg',
              scenes: ['static/img/looks/men/7/scene_1.jpg', 'static/img/looks/men/7/scene_2.jpg']
            },
            clothings: {
              top: ['RUN WARM+ MML JAUNE'],
              bottom: ['RUN WARM+ PANT NOIR'],
              shoes: ['RUN EKIPRIME  BLEU JAUNE'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES']
            },
            references: [8394839, 8394834, 8379974, 8325547]
          },
          8: {
            name: 'Look 8',
            hex_color: '#dcf78c',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/8/slide.jpg',
              large: 'static/img/looks/men/8/large.jpg',
              platter: 'static/img/looks/men/8/platter.jpg',
              scenes: ['static/img/looks/men/8/scene_1.jpg', 'static/img/looks/men/8/scene_2.jpg']
            },
            clothings: {
              top: ['RUN WARM+ VESTE SANS MANCHE JAUNE', 'RUN WARM+ MML NOIR'],
              bottom: ['RUN WARM+ COLLANT NOIR JAUNE'],
              shoes: ['RUN ELIORUN BLEU JAUNE'],
              accessories: ['EVOLUTIVE GLOVE BY NIGHT CHINE', 'SGN 400']
            },
            references: [8394832, 8394838, 8394843, 8379980, 8393526, 8394633]
          },
          9: {
            name: 'Look 9',
            hex_color: '#dce1e7',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/9/slide.jpg',
              large: 'static/img/looks/men/9/large.jpg',
              platter: 'static/img/looks/men/9/platter.jpg',
              scenes: ['static/img/looks/men/9/scene_1.jpg', 'static/img/looks/men/9/scene_2.jpg']
            },
            clothings: {
              top: ['RUN RAIN VESTE BLANCHE', 'RUN DRY+ T SHIRT NOIR CHINE'],
              bottom: ['RUN DRY+ SHORT NOIR', 'RUN WARM+ COLLANT'],
              shoes: ['RUN ACTIVE GRIP NOIR BLANC'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES']
            },
            references: [8394760, 8381934, 8381935, 8394833, 8379981, 8325547]
          },
          10: {
            name: 'Look 10',
            hex_color: '#f05A3C',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/10/slide.jpg',
              large: 'static/img/looks/men/10/large.jpg',
              platter: 'static/img/looks/men/10/platter.jpg',
              scenes: ['static/img/looks/men/10/scene_1.jpg', 'static/img/looks/men/10/scene_2.jpg']
            },
            clothings: {
              top: ['RUN WARM+ COUPE VENT ROUGE', 'RUN WARM+ MML NOIR CHINE'],
              bottom: ['RUN WARM+ PANT NOIR'],
              shoes: ['RUN ELIOFEET NOIR'],
              accessories: ''
            },
            references: [8394758, 8394838, 8394834, 8379975]
          },
          11: {
            name: 'Look 11',
            hex_color: '#000000',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/11/slide.jpg',
              large: 'static/img/looks/men/11/large.jpg',
              platter: 'static/img/looks/men/11/platter.jpg',
              scenes: ['static/img/looks/men/11/scene_1.jpg', 'static/img/looks/men/11/scene_2.jpg']
            },
            clothings: {
              top: ['RUN RAIN JACKET BLACK', 'RUN WARM+ MMLROUGE'],
              bottom: ['RUN WARM COLLANT PRINT'],
              shoes: ['RUN EKIPRIME BLEU ROUGE'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES']
            },
            references: [8394759, 8394842, 8394756, 8379987, 8155432]
          },
          12: {
            name: 'Look 12',
            hex_color: '#f05A3C',
            price: 0.00,
            designers_word: 'Find your rythm, enjoy your run ! Troverai il tuo ritmo in funzione delle tue capacità e sceglierai il tuo outfit in funzione dei tuoi gusti e delle tue emozioni.',
            designers_name: '',
            designers_job: '',
            images: {
              slide: 'static/img/looks/men/12/slide.jpg',
              large: 'static/img/looks/men/12/large.jpg',
              platter: 'static/img/looks/men/12/platter.jpg',
              scenes: ['static/img/looks/men/12/scene_1.jpg', 'static/img/looks/men/12/scene_2.jpg']
            },
            clothings: {
              top: ['RUN WARM+ MML ROUGE'],
              bottom: ['RUN WARM+ PANT NOIR'],
              shoes: ['RUN ACTIVE GRIP KAKI'],
              accessories: ['CHAUSSETTES DE RUNNING ELIOFEEL HIGH NOIRES']
            },
            references: [8394842, 8394834, 8379986, 8155432]
          }
        },
        women: {
          1: {
            name: 'Look 1',
            hex_color: '#78748b',
            price: 0.00,
            designers_word: 'Con il gilet senza maniche, il freddo non sarà più una scusa per non correre! La combinazione nero e grigio si modernizza grazie al motivo cartografico. Sii un jogger urbano fino in fondo!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/1/slide.jpg',
              large: 'static/img/looks/women/1/large.jpg',
              platter: 'static/img/looks/women/1/platter.jpg',
              scenes: ['static/img/looks/women/1/scene_1.jpg', 'static/img/looks/women/1/scene_2.jpg']
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: ['']
            },
            references: [8395605, 8394798, 8380664, 8394797, 8380028, 8380908, 8325547, 8394633]
          },
          2: {
            name: 'Look 2',
            hex_color: '#f3532e',
            price: 0.00,
            designers_word: 'Questo outfit dona leggerezza e traspirabilità con un contrasto dinamico nero e corallo perfetto per la mezza stagione. Il corallo, è il nuovo colore fluo di moda!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/2/slide.jpg',
              large: 'static/img/looks/women/2/large.jpg',
              platter: 'static/img/looks/women/2/platter.jpg',
              scenes: ['static/img/looks/women/2/scene_1.jpg', 'static/img/looks/women/2/scene_2.jpg']
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: ['']
            },
            references: [8394790, 8367751, 8380013, 8380908, 8325547, 8393523]
          },
          3: {
            name: 'Look 3',
            hex_color: '#bbbdc3',
            price: 0.00,
            designers_word: 'Il semplice nero e grigio ti offriranno un outfit attuale e alla moda, assicurandoti sobrietà ed eleganza.',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/3/slide.jpg',
              large: 'static/img/looks/women/3/large.jpg',
              platter: 'static/img/looks/women/3/platter.jpg',
              scenes: ['static/img/looks/women/3/scene_1.jpg', 'static/img/looks/women/3/scene_2.jpg']
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: ['']
            },
            references: [8394796, 8367751, 8380028, 8380908, 8325547, 8393523, 8342130]
          },
          4: {
            name: 'Look 4',
            hex_color: '#f3532e',
            price: 0.00,
            designers_word: 'Dimentica il grigio delle giornate invernale e proteggiti dal vento con questo outfit corallo e arancione, per un look motivante e pieno di energia!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/4/slide.jpg',
              large: 'static/img/looks/women/4/large.jpg',
              platter: 'static/img/looks/women/4/platter.jpg',
              scenes: ['static/img/looks/women/4/scene_1.jpg', 'static/img/looks/women/4/scene_2.jpg']
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: ['']
            },
            references: [8394768, 8394780, 8370294, 8380013, 8380908, 8325547, 8342130]
          },
          5: {
            name: 'Look 5',
            hex_color: '#782949',
            price: 0.00,
            designers_word: 'Il bordeaux è il colore di questo inverno. Il gioco di colori di questo outfit risvegliera la tua femminilità. Girly ma non troppo!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/5/slide.jpg',
              large: 'static/img/looks/women/5/large.jpg',
              platter: 'static/img/looks/women/5/platter.jpg',
              scenes: ['static/img/looks/women/5/scene_1.jpg', 'static/img/looks/women/5/scene_2.jpg']
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: ['']
            },
            references: [8394794, 8394783, 8380019, 8380908, 8325547, 8393521]
          },
          6: {
            name: 'Look 6',
            hex_color: '#FF1E8C',
            price: 0.00,
            designers_word: 'Metti in risalto la tua femminilità e sportività con il classico nero e rosa fucsia. Tecnicità e femminilità assicurate!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/6/slide.jpg',
              large: 'static/img/looks/women/6/large.jpg',
              platter: 'static/img/looks/women/6/platter.jpg',
              scenes: ['static/img/looks/women/6/scene_1.jpg', 'static/img/looks/women/6/scene_2.jpg']
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: ['']
            },
            references: [8394779, 8370294, 8380012, 8380909, 8325547]
          },
          7: {
            name: 'Look 7',
            hex_color: '#006a84',
            price: 0.00,
            designers_word: 'In blu, con uno stile urbano, aggiungi colore e originalità alle tue corse!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/7/slide.jpg',
              large: 'static/img/looks/women/7/large.jpg',
              platter: 'static/img/looks/women/7/platter.jpg',
              scenes: ['static/img/looks/women/7/scene_1.jpg', 'static/img/looks/women/7/scene_2.jpg']
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: ['']
            },
            references: [8394781, 8394782, 8380014, 8380908, 8325547]
          },
          8: {
            name: 'Look 8',
            hex_color: '#dce1e7',
            price: 0.00,
            designers_word: 'Con questa panoplie nera e bianca, libera la tua voglia di correre anche sotto la pioggia. La giacca impermeabile con inserti catarifrangenti ti assicurerà impermeabilità e stile con tutte le condizioni metereologiche.',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/8/slide.jpg',
              large: 'static/img/looks/women/8/large.jpg',
              platter: 'static/img/looks/women/8/platter.jpg',
              scenes: ['static/img/looks/women/8/scene_1.jpg', 'static/img/looks/women/8/scene_2.jpg']
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: ['']
            },
            references: [8394767, 8394778, 8381587, 8380028, 8380908, 8393517]
          },
          9: {
            name: 'Look 9',
            hex_color: '#78748b',
            price: 0.00,
            designers_word: 'Gioca la sobrietà con un outfit nero e grigio con un dettaglio grafico e urbano.',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/9/slide.jpg',
              large: 'static/img/looks/women/9/large.jpg',
              platter: 'static/img/looks/women/9/platter.jpg',
              scenes: ['static/img/looks/women/9/scene_1.jpg', 'static/img/looks/women/9/scene_2.jpg']
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: ['']
            },
            references: [8394805, 8380664, 8394804, 8380024, 8380908, 8393526, 8393517, 8394633, 8325547]
          },
          10: {
            name: 'Look 10',
            hex_color: '#6ed5de',
            price: 0.00,
            designers_word: 'Con il pantalone Run Dry + e questo turchese, opta per un outfit fresco, perfetto per la mezza stagione.',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/10/slide.jpg',
              large: 'static/img/looks/women/10/large.jpg',
              platter: 'static/img/looks/women/10/platter.jpg',
              scenes: ['static/img/looks/women/10/scene_1.jpg', 'static/img/looks/women/10/scene_2.jpg']
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: ['']
            },
            references: [8394793, 8381587, 8380029, 8380908, 8325547]
          },
          11: {
            name: 'Look 11',
            hex_color: '#f3532e',
            price: 0.00,
            designers_word: 'Voglia di una corsa in compagnia della musica? Indossa la giacca Run Warm, pratica con il suo speciale passaggio per le auricolari. Osa con il bordeaux, per una delicata femminilità.',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/11/slide.jpg',
              large: 'static/img/looks/women/11/large.jpg',
              platter: 'static/img/looks/women/11/platter.jpg',
              scenes: ['static/img/looks/women/11/scene_1.jpg', 'static/img/looks/women/11/scene_2.jpg']
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: ['']
            },
            references: [8394802, 8394803, 8380019, 8380908, 8325547, 8393521, 8394633]
          },
          12: {
            name: 'Look 12',
            hex_color: '#2E4DA7',
            price: 0.00,
            designers_word: 'Per un outfit accessibile e morderno, la panoplie blu è perfetta per cambiare dal rosa, restando sportiva. Provaci!',
            designers_name: 'Élise',
            designers_job: 'Stilista femminile',
            images: {
              slide: 'static/img/looks/women/12/slide.jpg',
              large: 'static/img/looks/women/12/large.jpg',
              platter: 'static/img/looks/women/12/platter.jpg',
              scenes: ['static/img/looks/women/12/scene_1.jpg', 'static/img/looks/women/12/scene_2.jpg']
            },
            clothings: {
              top: '',
              bottom: '',
              shoes: '',
              accessories: ['']
            },
            references: [8394801, 8367751, 8380018, 8380908, 8325547]
          }
        }
      }
    };
  }
});
/* harmony default export */ __webpack_exports__["default"] = (vm);

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Intro__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Looks__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Looks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Looks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Look__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Look___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Look__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'active',
  mode: 'hash',
  base: '/',
  routes: [{ path: '/', name: 'intro', component: __WEBPACK_IMPORTED_MODULE_2__components_Intro___default.a }, { path: '/home', name: 'home', component: __WEBPACK_IMPORTED_MODULE_3__components_Home___default.a }, { path: '/looks/:gender', name: 'looks', component: __WEBPACK_IMPORTED_MODULE_4__components_Looks___default.a }, { path: '/looks/:gender/:id', name: 'look', component: __WEBPACK_IMPORTED_MODULE_5__components_Look___default.a }]
});

// Check Param Globally
router.beforeEach(function (to, from, next) {
  // Validate genders if param exists
  var validGenders = ['women', 'men'];
  if (to.params.gender && validGenders.indexOf(to.params.gender) === -1) {
    return next({ name: 'home' });
  }
  return next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint no-param-reassign: ["error", { "props": false }]*/
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    showCart: false,
    showBorders: true,
    prevLook: '',
    nextLook: '',
    currentgender: '',
    cart: [],
    selectedColor: ''
  },
  mutations: {
    showCart: function showCart(state) {
      state.showCart = true;
    },
    hideCart: function hideCart(state) {
      state.showCart = false;
    },
    hideBorders: function hideBorders(state) {
      state.showBorders = false;
    },
    showBorders: function showBorders(state) {
      state.showBorders = true;
    },
    nextLabel: function nextLabel(state, n) {
      state.nextLook = n;
    },
    prevLabel: function prevLabel(state, n) {
      state.prevLook = n;
    },
    currentGender: function currentGender(state, gender) {
      state.currentgender = gender;
    },
    addToCart: function addToCart(state, _ref) {
      var variant = _ref.variant;

      state.cart.push(variant);
    },
    incrementQty: function incrementQty(state, index) {
      state.cart[index].quantity += 1;
    },
    decrementQty: function decrementQty(state, index) {
      if (state.cart[index].quantity >= 2) {
        state.cart[index].quantity -= 1;
      } else {
        state.cart.splice(index, 1);
      }
    },
    selectedColor: function selectedColor(state, obj) {
      state.selectedColor = obj;
    }
  },
  getters: {
    cart: function cart(state) {
      return state.cart;
    },
    cartSize: function cartSize(state) {
      var total = 0;
      var i = 0;
      for (i; i < state.cart.length; i += 1) {
        total += parseInt(state.cart[i].quantity, 10);
      }
      return total;
    },
    getItemIndex: function getItemIndex(state) {
      return function (id) {
        return state.cart.findIndex(function (cart) {
          return cart.id === id;
        });
      };
    },
    cartExport: function cartExport(state) {
      var cartExp = [];
      state.cart.forEach(function (e, i) {
        var item = {};
        item.id = e.id;
        item.quantity = '' + e.quantity;
        cartExp[i] = item;
      });
      return cartExp;
    }
  }
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flickity__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_flickity__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        options: {
            type: Object,

            default: function _default() {
                return {};
            }
        }
    },

    mounted: function mounted() {
        this.init();
    },
    beforeDestroy: function beforeDestroy() {
        this.flickity.destroy();
        this.flickity = null;
    },


    methods: {
        init: function init() {
            this.flickity = new __WEBPACK_IMPORTED_MODULE_0_flickity___default.a(this.$el, this.options);
        },
        next: function next(isWrapped, isInstant) {
            this.flickity.next(isWrapped, isInstant);
        },
        previous: function previous(isWrapped, isInstant) {
            this.flickity.previous(isWrapped, isInstant);
        },
        select: function select(index, isWrapped, isInstant) {
            this.flickity.select(index, isWrapped, isInstant);
        },
        selectedIndex: function selectedIndex() {
            return this.flickity.selectedIndex;
        },
        selectCell: function selectCell(value, isWrapped, isInstant) {
            this.flickity.selectCell(value, isWrapped, isInstant);
        },
        resize: function resize() {
            this.flickity.resize();
        },
        reposition: function reposition() {
            this.flickity.reposition();
        },
        prepend: function prepend(elements) {
            this.flickity.prepend(elements);
        },
        append: function append(elements) {
            this.flickity.append(elements);
        },
        insert: function insert(elements, index) {
            this.flickity.insert(elements, index);
        },
        remove: function remove(elements) {
            this.flickity.remove(elements);
        },
        playPlayer: function playPlayer() {
            this.flickity.playPlayer();
        },
        stopPlayer: function stopPlayer() {
            this.flickity.stopPlayer();
        },
        pausePlayer: function pausePlayer() {
            this.flickity.pausePlayer();
        },
        unpausePlayer: function unpausePlayer() {
            this.flickity.unpausePlayer();
        },
        rerender: function rerender() {
            this.flickity.destroy();
            this.init();
        },
        destroy: function destroy() {
            this.flickity.destroy();
        },
        reloadCells: function reloadCells() {
            this.flickity.reloadCells();
        },
        getCellElements: function getCellElements() {
            this.flickity.getCellElements();
        },
        data: function data() {
            return __WEBPACK_IMPORTED_MODULE_0_flickity___default.a.data(this.$el);
        },
        on: function on(eventName, listener) {
            this.flickity.on(eventName, listener);
        },
        off: function off(eventName, listener) {
            this.flickity.off(eventName, listener);
        },
        once: function once(eventName, listener) {
            this.flickity.once(eventName, listener);
        }
    }

});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a },
  data: function data() {
    return {
      title: 'Kalenji by Decathlon'
    };
  },

  head: {
    title: function title() {
      return {
        inner: this.title,
        separator: '–'
      };
    },
    meta: function meta() {
      return [{ name: 'description', content: '' }];
    }
  },
  created: function created() {
    window.vm = this;
    this.$store.commit('hideCart');
  },
  mounted: function mounted() {
    if (this.$cookie.get('basket')) {
      this.$store.state.cart = JSON.parse(this.$cookie.get('basket'));
    }
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'borders',
  props: {
    showCorners: {
      type: Boolean,
      required: true
    },
    showText: {
      type: Boolean,
      required: true
    },
    prevLabel: {
      type: [String, Number],
      required: false
    },
    nextLabel: {
      type: [String, Number],
      required: false
    },
    nextArrow: {
      type: Boolean,
      required: false
    },
    prevArrow: {
      type: Boolean,
      required: false
    },
    showGender: {
      type: String,
      required: false
    },
    showChevronDown: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      showScroll: false
    };
  },

  computed: {
    showBorders: function showBorders() {
      return this.$store.state.showBorders;
    },
    genderType: function genderType() {
      var gender = '';
      if (this.showGender === 'men') {
        gender = 'Uomo';
      } else if (this.showGender === 'women') {
        gender = 'Donna';
      }
      return gender;
    }
  },
  methods: {
    getNext: function getNext() {
      this.$root.$emit('goto', 'next');
    },
    getPrev: function getPrev() {
      this.$root.$emit('goto', 'prev');
    },
    getNextSlider: function getNextSlider() {
      this.$root.$emit('posSlider', 'next');
    },
    getPrevSlider: function getPrevSlider() {
      this.$root.$emit('posSlider', 'prev');
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(56);

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cart',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['cartSize']))
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Borders__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Borders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Borders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(56);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cart',
  components: {
    borders: __WEBPACK_IMPORTED_MODULE_2__components_Borders___default.a
  },
  data: function data() {
    return {};
  },

  methods: {
    increment: function increment(id) {
      this.$store.commit('incrementQty', id);
      this.setCookie();
    },
    decrement: function decrement(id) {
      this.$store.commit('decrementQty', id);
      this.setCookie();
    },
    setCookie: function setCookie() {
      this.$cookie.set('basket', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.$store.state.cart), 30);
    },
    closeSummary: function closeSummary() {
      this.$parent.$emit('closeSummary');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['cartExport', 'cart', 'cartSize']), {
    total: function total() {
      var totalprice = 0;
      var i = 0;
      for (i; i < this.cart.length; i += 1) {
        totalprice += parseFloat(this.cart[i].quantity * this.cart[i].price, 10);
      }
      return totalprice.toFixed(2);
    },
    exportURL: function exportURL() {
      var obj = {
        basket: {
          identifier: 'DressYourRun',
          products: this.cartExport
        }
      };
      return 'https://www.decathlon.it/it/importExternalBasket?jsonString=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj));
    }
  })
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Borders__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Borders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Borders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scrollmagic__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scrollmagic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scrollmagic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_scrollmagic_scrollmagic_uncompressed_plugins_animation_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_plyr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_plyr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: { borders: __WEBPACK_IMPORTED_MODULE_0__components_Borders___default.a, plyr: __WEBPACK_IMPORTED_MODULE_4_plyr___default.a, TweenMax: __WEBPACK_IMPORTED_MODULE_2_gsap__["TweenMax"], ScrollMagic: __WEBPACK_IMPORTED_MODULE_1_scrollmagic___default.a },
  data: function data() {
    return {
      showVid: false,
      videoSrc: 'https://www.decathlon.fr/ecfr/static/concept/kalenji/mnr/static/klnj.mp4',
      videoType: 'video/mp4',
      player: null,
      sectionHeight: '',
      plyrOptions: {
        volume: 5,
        autoplay: true,
        clickToPlay: false,
        controls: ['mute']
      }
    };
  },

  methods: {
    createVideo: function createVideo() {
      this.showVid = true;
    },
    setAnim: function setAnim() {
      var _this = this;

      var borderWidth = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].outerHeight(document.getElementsByClassName('mxr-l-borders--top')[0]);
      if (!__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].isTouchDevice) {
        window.onresize = function () {
          _this.sectionHeight = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getBorderedViewport();
        };
      }
      // Animation
      var controller = new __WEBPACK_IMPORTED_MODULE_1_scrollmagic___default.a.Controller();
      var intro = new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]().fromTo('#mxr-logo', 1, { y: -30, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power4"].easeInOut }).fromTo('.section--1 .light', 2, { height: '100%', width: '20%', autoAlpha: 0 }, { height: '100%', width: '70%', autoAlpha: 1, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power4"].easeInOut }).fromTo('.section--1 .icon-scroll', 1, { y: 250, autoAlpha: 0 }, { y: 0, autoAlpha: 1 });
      new __WEBPACK_IMPORTED_MODULE_1_scrollmagic___default.a.Scene({
        triggerElement: '.section--1'
      }).setTween(intro) // trigger a TweenMax.to tween
      .addTo(controller);

      var wipeAnimation = new __WEBPACK_IMPORTED_MODULE_2_gsap__["TimelineMax"]().fromTo('.panel--freedom .light', 1, { height: '100%', width: '50%', autoAlpha: 0, xPercent: '-50%' }, { height: '100%', width: '30%', autoAlpha: 0.9, xPercent: '0' }).staggerFromTo('.panel--freedom .word span', 0.5, { y: 120, autoAlpha: 0, scale: 1.4 }, { y: 0, autoAlpha: 1, scale: 1 }, 0.15).to('.panel--freedom .panel__picture .filter', 1, { autoAlpha: 0 }).to('.panel--freedom .light', 1.2, { autoAlpha: 0, xPercent: '-50%', delay: -1.5 }).to('.panel--freedom .panel__picture', 5, { scale: 1.1, delay: -3.2, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power2"].easeInOut })
      // animate to second panel
      .to('#storyContainer', 0.5, { z: -200, delay: 1 }) // move back in 3D space
      .to('#storyContainer', 2, { x: '-33.3333333%', ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power2"].easeInOut }) // move in to first panel
      .to('#storyContainer', 0.5, { z: 0 }) // move back to origin in 3D space

      .fromTo('.panel--happiness .light', 1, { height: '100%', width: '50%', autoAlpha: 0, xPercent: '50%' }, { height: '100%', width: '30%', autoAlpha: 0.9, xPercent: '0' }).staggerFromTo('.panel--happiness .word span', 0.5, { y: 120, autoAlpha: 0, scale: 1.4 }, { y: 0, autoAlpha: 1, scale: 1 }, 0.15).to('.panel--happiness .panel__picture .filter', 1, { autoAlpha: 0 }).to('.panel--happiness .light', 1.2, { autoAlpha: 0, xPercent: '50%', delay: -1.5 }).to('.panel--happiness .panel__picture', 5, { scale: 1.1, delay: -3.2, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power2"].easeInOut })

      // animate to third panel
      .to('#storyContainer', 0.5, { z: -200, delay: 1 }).to('#storyContainer', 2, { x: '-66.6666666%', ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power2"].easeInOut }).to('#storyContainer', 0.5, { z: 0 }).fromTo('.panel--achievement .light', 1, { height: '100%', width: '50%', autoAlpha: 0, xPercent: '50%' }, { height: '100%', width: '30%', autoAlpha: 0.9, xPercent: '0' }).staggerFromTo('.panel--achievement .word span', 0.5, { y: 120, autoAlpha: 0, scale: 1.4 }, { y: 0, autoAlpha: 1, scale: 1 }, 0.15).to('.panel--achievement .panel__picture .filter', 1, { autoAlpha: 0 }).to('.panel--achievement .light', 1.2, { autoAlpha: 0, xPercent: '-50%', delay: -1.5 }).to('.panel--achievement .panel__picture', 5, { scale: 1.1, delay: -3.2, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power2"].easeInOut }).to('.mxr-l-borders__vtext', 1, { autoAlpha: 0, ease: __WEBPACK_IMPORTED_MODULE_2_gsap__["Power2"].easeInOut });

      if (document.getElementById('pinContainer').length !== 0) {
        new __WEBPACK_IMPORTED_MODULE_1_scrollmagic___default.a.Scene({
          triggerElement: '#pinContainer',
          triggerHook: 'onLeave',
          offset: '-' + borderWidth,
          duration: '400%'
        }).setPin('#pinContainer').setTween(wipeAnimation).addTo(controller);
      }
    }
  },
  mounted: function mounted() {
    this.$store.commit('hideCart');
    this.$store.commit('showBorders');
    this.sectionHeight = __WEBPACK_IMPORTED_MODULE_5__utils__["a" /* default */].getBorderedViewport();
    if (this.$route.name === 'home') {
      this.setAnim();
    }
  },
  updated: function updated() {
    var _this2 = this;

    this.player = __WEBPACK_IMPORTED_MODULE_4_plyr___default.a.setup(document.querySelector('#vklnj'), this.plyrOptions)[0];
    if (this.showVid && this.player !== '') {
      this.player.on('ended', function (e) {
        _this2.player = e.detail.plyr;
        // console.log(e.detail.plyr);
        _this2.showVid = false;
        // this.player.destroy();
        _this2.player = '';
      });
    }
  }
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Borders__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Borders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Borders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var tl = new __WEBPACK_IMPORTED_MODULE_1_gsap__["TimelineMax"]({ repeat: 0 });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'intro',
  components: { borders: __WEBPACK_IMPORTED_MODULE_0__components_Borders___default.a },
  data: function data() {
    return {
      sectionHeight: ''
    };
  },

  methods: {
    animLogo: function animLogo() {
      var _this = this;

      // const paths = $('path:not(defs path)');
      var paths = document.getElementById('animPath');
      paths.style.strokeDasharray = paths.getTotalLength();
      paths.style.strokeDashoffset = paths.getTotalLength();
      tl.add([__WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].set(paths, { autoAlpha: 0 }), __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].set('.logotype__wrap', { width: 0 }), __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].set('.logotype', { autoAlpha: 1 }), __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(paths, 0.5, { autoAlpha: 1 }), __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to(paths, 1.4, { strokeDashoffset: 0, delay: 0.5 }), __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].to('.logotype__wrap', 1, { width: '54%', delay: 2.3, ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Power4"].easeInOut }), __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].staggerFromTo('.logotype > g', 1.5, { y: 100, autoAlpha: 0 }, { y: 0, autoAlpha: 1, delay: 2.5, ease: __WEBPACK_IMPORTED_MODULE_1_gsap__["Elastic"].easeOut.config(0.8, 0.35) }, 0.1), __WEBPACK_IMPORTED_MODULE_1_gsap__["TweenMax"].fromTo('.logo-by-decathlon__wrap', 1, { autoAlpha: 0, y: -20 }, { autoAlpha: 1, y: 0, delay: 3.8 })]);
      tl.add(function () {
        setTimeout(function () {
          if (_this.$route.name === 'intro') {
            _this.$router.push({ path: '/home' });
          }
        }, 800);
      });
    }
  },
  mounted: function mounted() {
    this.sectionHeight = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].getBorderedViewport();
    this.animLogo();
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Borders__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Borders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Borders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProductAdd__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProductAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ProductAdd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductPic__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductPic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ProductPic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap_ScrollToPlugin__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_gsap_ScrollToPlugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_gsap_ScrollToPlugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProductDeclination__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProductDeclination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ProductDeclination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_flickity__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(50);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'looks',
  components: {
    borders: __WEBPACK_IMPORTED_MODULE_1__components_Borders___default.a,
    productPic: __WEBPACK_IMPORTED_MODULE_3__components_ProductPic___default.a,
    productAdd: __WEBPACK_IMPORTED_MODULE_2__components_ProductAdd___default.a,
    productDeclination: __WEBPACK_IMPORTED_MODULE_6__components_ProductDeclination___default.a,
    Flickity: __WEBPACK_IMPORTED_MODULE_7_vue_flickity___default.a
  },
  head: {
    title: function title() {
      return {
        inner: 'Kalenji by Decathlon',
        separator: '–',
        complement: 'Look ' + this.genderType + ' #' + this.$options.filters.padToTwo(this.$route.params.id)
      };
    },
    meta: function meta() {
      return [{ name: 'description', content: this.look.designers_word || 'Find your rhythm, enjoy your run ! Chacun trouvera son rythme en fonction de ses capacités, chacun trouvera son style en fonction de ses envies et de ses émotions.' }];
    }
  },
  data: function data() {
    return {
      gender: this.$route.params.gender,
      lookId: this.$route.params.id,
      look: this.$root.looks[this.$route.params.gender][this.$route.params.id],
      looks: this.$root.looks[this.$route.params.gender],
      looksGenderSize: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$root.looks[this.$route.params.gender]).length,
      products: [],
      sectionHeight: '',
      currentId: '',
      currentProdPrice: '',
      flickityOptions: {
        initialIndex: 0,
        setGallerySize: true,
        imagesLoaded: false,
        percentPosition: true,
        groupCells: false,
        bgLazyLoad: false,
        contain: false,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        accessibility: true
      }
    };
  },

  computed: {
    nextLabel: function nextLabel() {
      var nextLabel = parseInt(this.lookId, 10) + 1;
      nextLabel = this.looksGenderSize >= nextLabel ? nextLabel : 1;
      return nextLabel;
    },
    prevLabel: function prevLabel() {
      var prevLabel = parseInt(this.lookId, 10) - 1;
      prevLabel = prevLabel > 0 ? prevLabel : 12;
      return prevLabel;
    },
    cartFiltered: function cartFiltered() {
      var _this = this;

      return this.$store.getters.cart.filter(function (p) {
        return p.gender === _this.$route.params.gender;
      }).filter(function (p) {
        return parseInt(p.look, 10) === parseInt(_this.$route.params.id, 10);
      });
    },
    productFiltered: function productFiltered() {
      var _this2 = this;

      return this.products.filter(function (p) {
        return p.productInfo.productId === _this2.currentId;
      });
    },
    genderType: function genderType() {
      var gender = '';
      if (this.gender === 'men') {
        gender = 'Uomo';
      } else if (this.gender === 'women') {
        gender = 'Donna';
      }
      return gender;
    },
    totalPrice: function totalPrice() {
      var total = 0;
      var prices = this.products.map(function (p) {
        return p.productVariant[0].price;
      });
      total = prices.reduce(function (pv, cv) {
        return pv + cv;
      }, 0);
      return total.toFixed(2);
    }
  },
  methods: {
    changeItem: function changeItem(event) {
      this.selector = event.target.id;
      this.product.id = event.target.value;
    },
    scrollNavUp: function scrollNavUp() {
      var currPos = document.querySelectorAll('.carousel-nav__inner')[0].scrollTop;
      __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to('.carousel-nav__inner', 1, { scrollTo: currPos - 112, ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power4"].easeOut });
    },
    scrollNavDown: function scrollNavDown() {
      var currPos = document.querySelectorAll('.carousel-nav__inner')[0].scrollTop;
      __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenMax"].to('.carousel-nav__inner', 1, { scrollTo: currPos + 112, ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power4"].easeOut });
    },
    selectIndex: function selectIndex(e, index) {
      this.$refs.looksProductSlider.select(index);
      /* function offset(elt) {
        const rect = elt.getBoundingClientRect();
        const bodyElt = document.body;
        return {
          top: rect.top + bodyElt.scrollTop,
          left: rect.left + bodyElt.scrollLeft,
        };
      }
      const carouselNav = document.querySelectorAll('.carousel-nav')[0];
      const carouselNavInner = carouselNav.querySelectorAll('.carousel-nav__inner')[0];
      const cell = carouselNavInner.querySelectorAll('.carousel-cell')[0];
      const navHeight = carouselNav.clientHeight;
      const navInnerHeight = carouselNavInner.clientHeight;
      const cellHeight = cell.clientHeight;
       const cellPos = offset(e.target).top - offset(carouselNavInner).top;
      const scrollY = ((cellPos + cellHeight) + (navHeight / 2)) - (navInnerHeight / 2);
      console.log(scrollY);
      TweenMax.to('.carousel-nav', 1, { scrollTo: scrollY, ease: Power4.easeOut }); */
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$store.commit('nextLabel', this.nextLabel);
    this.$store.commit('prevLabel', this.prevLabel);
    this.$store.commit('currentGender', this.$route.params.gender);
    this.$store.commit('showCart');
    this.$store.commit('showBorders');
    this.sectionHeight = __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].getBorderedViewport();
    this.$on('currentProdPrice', function (value) {
      _this3.currentProdPrice = value;
    });
    this.$root.$on('goto', function (value) {
      if (value === 'next') {
        _this3.$router.push({ path: '/looks/' + _this3.$store.state.currentgender + '/' + _this3.$store.state.nextLook });
      } else if (value === 'prev') {
        _this3.$router.push({ path: '/looks/' + _this3.$store.state.currentgender + '/' + _this3.$store.state.prevLook });
      }
    });
    __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* default */].fetchAllProducts(this.look.references, function (array) {
      _this3.products = array;
    });
  },
  updated: function updated() {
    var _this4 = this;

    if (this.products.length) {
      this.currentId = this.$refs.looksProductSlider.data().selectedElement.dataset.product;
      this.$refs.looksProductSlider.on('select', function () {
        _this4.currentId = _this4.$refs.looksProductSlider.data().selectedElement.dataset.product;
      });
    }
  }
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Borders__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Borders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Borders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_flickity__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_flickity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_flickity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity_imagesloaded__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_flickity_imagesloaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_flickity_imagesloaded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flickity_bg_lazyload__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flickity_bg_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flickity_bg_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'looks',
  components: {
    borders: __WEBPACK_IMPORTED_MODULE_0__components_Borders___default.a,
    Flickity: __WEBPACK_IMPORTED_MODULE_1_vue_flickity___default.a
  },
  head: {
    title: function title() {
      return {
        inner: 'Kalenji by Decathlon',
        separator: '–',
        complement: 'Looks ' + this.genderType
      };
    },
    meta: function meta() {
      return [{ name: 'description', content: 'Collection Automne-Hiver 2017 - looks ' + this.genderType }];
    }
  },
  data: function data() {
    return {
      gender: this.$route.params.gender,
      looks: this.$root.looks,
      animateTransition: false,
      sectionHeight: '',
      animTouch: false,
      flickityOptions: {
        initialIndex: 0,
        setGallerySize: true,
        imagesLoaded: true,
        percentPosition: true,
        groupCells: '100%',
        bgLazyLoad: 2,
        contain: false,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        accessibility: true
      }
    };
  },

  computed: {
    genderType: function genderType() {
      var gender = '';
      if (this.gender === 'men') {
        gender = 'Uomo';
      } else if (this.gender === 'women') {
        gender = 'Donna';
      }
      return gender;
    }
  },
  methods: {
    hexToRGB: function hexToRGB(val, alpha) {
      var r = parseInt(val.slice(1, 3), 16);
      var g = parseInt(val.slice(3, 5), 16);
      var b = parseInt(val.slice(5, 7), 16);
      var color = '';
      var a = alpha;

      if (a !== '') {
        color = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
      } else {
        color = 'rgb(' + r + ',' + g + ',' + b + ')';
      }
      return color;
    },
    setAnimTouch: function setAnimTouch() {
      var _this = this;

      if (__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].isTouchDevice()) {
        this.animTouch = true;
      }
      setTimeout(function () {
        _this.animTouch = false;
      }, 2500);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    /* if (this.$route.hash !== '') {
      const hash = parseInt(this.$route.hash.substring(1), 10);
      this.$refs.flickity.select(hash, false, true);
    }*/
    this.$store.commit('hideCart');
    this.$store.commit('showBorders');
    /* this.$refs.flickity.on('settle', () => {
      history.pushState(null, null, `#${this.$refs.flickity.selectedIndex()}`);
    });*/
    this.$refs.flickity.on('staticClick', function (e) {
      var lookId = e.target.getAttribute('data-look');
      _this2.animateTransition = true;
      setTimeout(function () {
        _this2.$router.push({ path: '/looks/' + _this2.gender + '/' + lookId });
      }, 1100);
      _this2.$gtm.trackEvent({
        event: 'lookClick',
        category: 'Interactions',
        action: 'click',
        label: 'Look visit',
        lookGender: _this2.gender,
        lookId: 'Look ' + lookId
      });
    });
    this.sectionHeight = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getBorderedViewport();
    this.setAnimTouch();
  },
  updated: function updated() {
    var _this3 = this;

    this.$root.$on('posSlider', function (value) {
      if (value === 'next') {
        _this3.$refs.flickity.next();
      } else if (value === 'prev') {
        _this3.$refs.flickity.previous();
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('posSlider');
  }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Cart__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CartSummary__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CartSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CartSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(56);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import utils from '../utils';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation',
  components: {
    cart: __WEBPACK_IMPORTED_MODULE_2__components_Cart___default.a, cartSummary: __WEBPACK_IMPORTED_MODULE_3__components_CartSummary___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])({
    products: 'cartExport',
    cartSize: 'cartSize'
  }), {
    showCart: function showCart() {
      return this.$store.state.showCart;
    },
    exportURL: function exportURL() {
      var obj = {
        basket: {
          identifier: 'DressYourRun',
          products: this.products
        }
      };
      return 'https://www.decathlon.fr/fr/importExternalBasket?jsonString=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
    }
  }),
  methods: {
    showSummary: function showSummary() {
      // if (!utils.isTouchDevice()) {
      //   this.active = true;
      // }
      this.active = !this.active;
    },
    hideSummary: function hideSummary() {
      /* if (!utils.isTouchDevice()) {
        this.active = false;
      } */
      this.active = false;
    }
  },
  data: function data() {
    return {
      active: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$on('closeSummary', function () {
      _this.showSummary();
    });
  }
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(56);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'product-add',
  props: ['product'],
  data: function data() {
    return {
      selectedVariant: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    variants: function variants() {
      return this.product.productVariant || [];
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getItemIndex']), {
    color: function color() {
      return this.$parent.look.hex_color;
    },
    selectedColor: function selectedColor() {
      return this.$store.state.selectedColor;
    },
    currentProdPrice: function currentProdPrice() {
      var price = '';
      if (this.selectedColor && this.product.productInfo.productId === this.selectedColor[1]) {
        price = this.selectedColor[0].productVariant[0].price;
      } else if (this.selectedColor && this.product.productInfo.productId === this.selectedColor[1] && this.selectedVariant) {
        price = this.selectedVariant.price;
      } else {
        price = this.variants[0].price;
      }
      // return price;
      this.$parent.$emit('currentProdPrice', price);
      price = '';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['addToCart']), {
    submitted: function submitted() {
      var variant = {};
      variant.id = this.selectedVariant.variantId;
      variant.quantity = 1;
      variant.name = this.product.openGraph.title;
      variant.price = this.selectedVariant.price;
      variant.image = this.selectedColor ? this.selectedColor[0].openGraph.image : this.product.openGraph.image;
      variant.size = this.selectedVariant.description;
      variant.currency = this.selectedVariant.currency;
      var indexExistingId = this.getItemIndex(variant.id);
      if (indexExistingId !== -1) {
        this.$store.commit('incrementQty', indexExistingId);
      } else {
        this.addToCart({ variant: variant });
      }
      this.selectedVariant = {};
      this.$cookie.set('basket', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.cart), 30);
    }
  })
});

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'product-declination',
  props: ['product'],
  data: function data() {
    return {
      selectedColor: []
    };
  },

  methods: {
    getProduct: function getProduct(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].fetchProduct(id, function (data) {
        _this.selectedColor = data;
        _this.$store.commit('selectedColor', [_this.selectedColor, _this.product.productInfo.productId]);
      });
    }
  },
  updated: function updated() {
    this.$store.commit('selectedColor', [this.product, this.product.productInfo.productId]);
  }
});

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'product-pic',
  props: ['product'],
  data: function data() {
    return {};
  },

  computed: {
    selectedColor: function selectedColor() {
      return this.$store.state.selectedColor;
    }
  }
});

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 400:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 405:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 407:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kalenji-by-decathlon.05ebd42.svg";

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(400)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(453),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(460),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(408)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(462),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9169e9a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(404)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(457),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c6d7905",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(454),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(398)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(451),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(452),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0beee204",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(409)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(463),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-97e92d8c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(458),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d68f958",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(456),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(461),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f6095c1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 451:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main', {
    attrs: {
      "role": "primary"
    }
  }, [_c('div', {
    staticClass: "row expanded collapse"
  }, [_c('div', {
    staticClass: "small-12 large-6 column"
  }, [_c('div', {
    staticClass: "mxr-look",
    style: ({
      height: (_vm.sectionHeight + "px")
    })
  }, [(_vm.totalPrice !== '0.00') ? _c('div', {
    staticClass: "mxr-product-price"
  }, [_c('div', {
    staticClass: "st-price"
  }, [_c('div', {
    staticClass: "price-info"
  }), _vm._v(" "), _c('div', {
    staticClass: "pricetag"
  }, [_c('div', {
    staticClass: "price"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("getAmount")(_vm.totalPrice)) + "€\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "decimal"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("getCents")(_vm.totalPrice)) + "\n                ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mxr-look__large",
    style: ({
      background: ("url(" + (_vm.look.images.large) + ") center center / cover")
    })
  }, [_c('div', {
    staticClass: "mxr-look__large--hover",
    style: ({
      background: ("url(" + (_vm.look.images.platter) + ") center center / cover")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "mxr-look__title show-for-medium"
  }, [_c('h2', {
    directives: [{
      name: "colorize",
      rawName: "v-colorize",
      value: (_vm.look.hex_color),
      expression: "look.hex_color"
    }]
  }, [_vm._v("#" + _vm._s(_vm._f("padToTwo")(_vm.lookId)))])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 large-6 column"
  }, [_c('div', {
    staticClass: "mxr-look__scene--head"
  }, [(_vm.look.images.scenes) ? _c('img', {
    attrs: {
      "src": _vm.look.images.scenes[0],
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mxr-look__content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.look.designers_word) ? _c('div', {
    staticClass: "column small-10 medium-6"
  }, [_c('blockquote', {
    staticClass: "mxr-quote"
  }, [_c('p', [_vm._v("“" + _vm._s(_vm.look.designers_word) + "”")]), _vm._v(" "), _c('cite', [_c('strong', [_vm._v(_vm._s(_vm.look.designers_name))]), _vm._v(", " + _vm._s(_vm.look.designers_job))])])], 1) : _c('div', {
    staticClass: "column small-10 medium-6"
  }, [_c('blockquote', {
    staticClass: "mxr-quote"
  }, [_c('p', [_vm._v("Find your rythm, enjoy your run ! Chacun trouvera son rythme en fonction de ses capacités, chacun trouvera son style en fonction de ses envies et de ses émotions.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column medium-5 show-for-large"
  }, [_c('div', {
    staticClass: "mxr-product-count"
  }, [_c('div', {
    directives: [{
      name: "colorize",
      rawName: "v-colorize",
      value: (_vm.look.hex_color),
      expression: "look.hex_color"
    }],
    staticClass: "mxr-product-count__num"
  }, [_vm._v(_vm._s((_vm.products).length))]), _vm._v(" "), _c('div', {
    staticClass: "mxr-product-count__word"
  }, [_vm._v("Prodotti")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row collapse align-right"
  }, [_c('div', {
    staticClass: "small-12 large-9 column"
  }, [_c('div', {
    staticClass: "show-for-small hide-for-medium"
  }, [(_vm.look.images.scenes) ? _c('img', {
    attrs: {
      "src": _vm.look.images.platter,
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mxr-look__scene--body"
  }, [(_vm.look.images.scenes) ? _c('img', {
    attrs: {
      "src": _vm.look.images.scenes[1],
      "alt": ""
    }
  }) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "mxr-look__products"
  }, [_c('nav', {
    staticClass: "carousel-nav"
  }, [_c('button', {
    staticClass: "button top show-for-large",
    on: {
      "click": _vm.scrollNavUp
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-chevron-up"
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-nav__inner"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "carousel-cell",
      on: {
        "click": function($event) {
          _vm.selectIndex($event, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": product.openGraph.image,
        "alt": "",
        "width": "62"
      }
    })])
  })), _vm._v(" "), _c('button', {
    staticClass: "button bottom show-for-large",
    on: {
      "click": _vm.scrollNavDown
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-chevron-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mxr-look__slider__wrap"
  }, [_c('div', {
    staticClass: "mxr-product-price"
  }, [_c('div', {
    staticClass: "st-price"
  }, [_c('div', {
    staticClass: "price-info"
  }), _vm._v(" "), _c('div', {
    staticClass: "pricetag"
  }, [_c('div', {
    staticClass: "price"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("getAmount")(_vm.currentProdPrice)) + "€\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "decimal"
  }, [_vm._v("\n                  " + _vm._s(_vm._f("getCents")(_vm.currentProdPrice)) + "\n                ")])])])]), _vm._v(" "), (_vm.products.length) ? _c('flickity', {
    ref: "looksProductSlider",
    staticClass: "mxr-look__slider",
    attrs: {
      "options": _vm.flickityOptions
    }
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "cell",
      attrs: {
        "data-product": product.productInfo.productId
      }
    }, [_c('product-pic', {
      key: product.productInfo.productId,
      attrs: {
        "product": product
      }
    })], 1)
  })) : _vm._e()], 1), _vm._v(" "), (_vm.products.length) ? _c('div', {
    staticClass: "mxr-look__decli"
  }, [_c('product-declination', {
    attrs: {
      "product": _vm.productFiltered[0]
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('product-add', {
    attrs: {
      "product": _vm.productFiltered[0]
    }
  })], 1)])])]), _vm._v(" "), _c('borders', {
    attrs: {
      "prevLabel": _vm.prevLabel,
      "showChevronDown": true,
      "nextLabel": _vm.nextLabel,
      "show-corners": false,
      "show-text": false,
      "show-dots": false
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mxr-look__scroll hide-for-medium"
  }, [_c('i', {
    staticClass: "zmdi zmdi-chevron-down"
  })])
}]}

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main', {
    attrs: {
      "role": "primary"
    }
  }, [_c('div', {
    staticClass: "pane",
    class: {
      animate: _vm.animateTransition
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.animTouch) ? _c('div', {
    staticClass: "mxr-touch",
    on: {
      "click": function($event) {
        _vm.animTouch = false
      }
    }
  }, [_c('div', {
    staticClass: "mxr-touch__anim"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(435),
      "alt": "",
      "width": "50"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Sfoglia lateralmente "), _c('br'), _vm._v("per scoprire gli outfits")])]) : _vm._e()]), _vm._v(" "), _c('flickity', {
    ref: "flickity",
    class: ("mxr-slider-looks m-slider-looks--" + _vm.gender),
    style: ({
      height: (_vm.sectionHeight + "px")
    }),
    attrs: {
      "options": _vm.flickityOptions
    }
  }, _vm._l((_vm.looks[_vm.gender]), function(look, index) {
    return _c('div', {
      key: (index),
      staticClass: "cell",
      style: ({
        height: (_vm.sectionHeight + "px")
      }),
      attrs: {
        "data-src": look.images.large,
        "data-color": look.hex_color
      }
    }, [_c('div', {
      staticClass: "pane",
      style: ({
        background: ("linear-gradient(145deg, " + (_vm.hexToRGB(look.hex_color, 0)) + " 40%," + (_vm.hexToRGB(look.hex_color, 0.15)) + " 50%," + (_vm.hexToRGB(look.hex_color, 1)) + " 100%) 0 1000px no-repeat")
      }),
      attrs: {
        "data-look": (index)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "mxr-slider-looks__title"
    }, [_c('div', {
      staticClass: "type"
    }, [_vm._v("Outfit")]), _vm._v(" "), _c('div', {
      staticClass: "num"
    }, [_vm._v("#" + _vm._s(_vm._f("padToTwo")(index)))])]), _vm._v(" "), _c('div', {
      staticClass: "cell__inner",
      style: ({
        height: (_vm.sectionHeight + "px")
      }),
      attrs: {
        "data-look": (index),
        "data-flickity-bg-lazyload": look.images.large
      }
    })])
  }))], 1), _vm._v(" "), _c('borders', {
    attrs: {
      "show-corners": false,
      "showGender": _vm.gender,
      "prevArrow": true,
      "nextArrow": true,
      "show-text": false,
      "show-dots": false
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('vue-progress-bar'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route
  })], 1), _vm._v(" "), _c('navigation')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main', {
    attrs: {
      "role": "primary"
    }
  }, [_c('div', {
    staticClass: "row expanded collapse align-center"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "section--intro",
    style: ({
      height: (_vm.sectionHeight + "px")
    })
  }, [_c('div', {
    staticClass: "mxr-intro"
  }, [_c('div', {
    staticClass: "loader-logo__wrap"
  }, [_c('svg', {
    staticClass: "loader-logo",
    staticStyle: {
      "enable-background": "new 0 0 152.944 62.917"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 152.944 62.917",
      "xml:space": "preserve"
    }
  }, [_c('defs', [_c('clipPath', {
    attrs: {
      "id": "logoSymb"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M121.455,0.002H31.489c-6.72-0.073-14.067,2.44-19.612,6.875C4.341,12.905,0,21.852,0,31.458\n              c0,17.349,14.127,31.459,31.489,31.459h62.186l-0.029-0.043c6.502-4.964,22.696-18.842,30.573-28.364\n              c2.08-2.505,1.328-3.797-0.57-5.276c-9.599-7.496-11.594-8.144-26.906-5.911c-7.876,1.157-41.462,9.079-46.591,9.823\n              c-3.562,0.501-5.481,0.297-7.841-0.831c-6.898-3.726-15.567-8.603-16.997-9.426c0.524,1.831,2.061,3.616,3.247,4.553\n              c1.177,0.942,4.949,3.725,9.572,6.866c4.634,3.136,7.239,4.428,18.027,2.908c4.976-0.695,38.804-6.042,44.564-5.857\n              c2.419,0.084,2.436-0.014,4.989,2.177c0.683,0.58,0.922,1.387-0.035,2.237c-2.801,2.474-14.721,11.765-20.449,15.574h-53.74\n              c-10.978,0-19.911-8.921-19.911-19.891c0-13.698,11.914-19.883,19.96-19.883h89.917c10.97,0,19.906,8.916,19.906,19.883\n              c0,10.97-8.936,19.891-19.906,19.891h-1.785l-13.102,11.568h14.887c17.362,0,31.489-14.11,31.489-31.459\n              C152.944,14.12,138.817,0.002,121.455,0.002"
    }
  })])]), _vm._v(" "), _c('path', {
    attrs: {
      "id": "animPath",
      "clip-path": "url(#logoSymb)",
      "fill": "none",
      "stroke": "#ffffff",
      "stroke-width": "19",
      "stroke-miterlimit": "0",
      "d": "M24.312,22.89l17.657,11.892 c0,0,14.186,0.439,32.333-3.324c14.311-2.968,6.5-1.676,15.854-3.238c24.691-4.123,30.479,3.238,26.251,6.691\n              c-6.497,5.306-25.772,21.705-25.772,21.705H28.969c0,0-23.167-1.333-23.167-26.5s28.667-25.5,28.667-25.5h88.333\n              c0,0,24.333,3,24.333,25.167c0,18-7.329,26.809-22.162,26.72l-5.501,0.044c0,0-9.337-2.765-14.837,5.569"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "logotype__wrap"
  }, [_c('svg', {
    staticClass: "logotype",
    staticStyle: {
      "enable-background": "new 0 0 381.131 87.773"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 381.131 87.773",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M56.304,23.394H37.62L63.379,0H48.686L22.409,23.394H12.131V0H0v62.986h12.131V32.208H51.98v30.778\n                h12.111V30.375C64.091,26.542,60.493,23.394,56.304,23.394"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M135.717,23.394H79.417v8.813h52.001v7.287h-45.13c-3.726,0-6.838,3.586-6.838,7.751v8.564\n                  c0.29,3.885,3.316,7.176,6.838,7.176h57.212V30.375C143.499,26.542,139.922,23.394,135.717,23.394z M131.417,54.064H91.393V46.8\n                  h40.024V54.064z"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "157.651",
      "width": "12.161",
      "height": "63.002"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M248.012,46.825V30.519c-0.331-3.907-3.366-7.124-6.863-7.124h-30.735l-0.008,0.024h-18.773\n                    c-3.87,0-7.225,2.72-7.669,6.187v26.33c0,3.859,3.555,6.989,7.737,7.01h56.311v-8.82h-52.026v-7.302H248.012z M195.986,32.28h40.057\n                    v7.264h-40.057V32.28z"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M327.433,62.901V30.266c0-3.723-3.569-6.871-7.764-6.871h-56.532v39.506h12.119V32.127h40.121v30.774\n                      H327.433z"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M342.22,67.384c0,1.918-1.333,3.154-1.333,3.154l-18.608,17.235h14.911l14.51-14.276\n                        c0,0,2.57-2.237,2.57-6.094V23.394H342.22V67.384z"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "342.22",
      "y": "4.793",
      "width": "12.051",
      "height": "9.684"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "369.098",
      "y": "23.394",
      "width": "12.033",
      "height": "39.493"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "369.098",
      "y": "4.793",
      "width": "12.033",
      "height": "9.684"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "mxr-intro__dkt"
  }, [_c('div', {
    staticClass: "logo-by-decathlon__wrap"
  }, [_c('svg', {
    staticClass: "logo-by-decathlon",
    staticStyle: {
      "enable-background": "new 0 0 244.265 47.783"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 244.265 47.783",
      "xml:space": "preserve"
    }
  }, [_c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "58.018",
      "y": "4.442",
      "width": "183.152",
      "height": "40.228"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M23.896,15.561c1.05,0.516,1.66,1.184,1.815,2.059c0.149,0.852,0.009,1.759-0.449,2.742\n                c-0.455,0.971-1.144,1.975-2.025,2.999c-0.904,1.004-1.87,1.928-2.917,2.739c-0.125,0.114-0.309,0.251-0.531,0.4\n                c-0.219,0.152-0.449,0.318-0.659,0.464c-0.236,0.163-0.455,0.306-0.656,0.429c-0.207,0.122-0.353,0.234-0.455,0.312\n                c-1.523,0.937-3.072,1.736-4.63,2.407c-1.561,0.648-3.235,1.272-5.026,1.841c-0.791,0.134-1.497,0.166-2.098,0.085\n                c-0.598-0.085-1.106-0.236-1.505-0.42c-0.399-0.207-0.694-0.435-0.878-0.68c-0.198-0.263-0.274-0.485-0.245-0.68\n                c0.77,0.14,1.351,0.219,1.747,0.228c0.403,0.015,0.706,0,0.94-0.047c0.225-0.041,0.376-0.091,0.467-0.169\n                c0.099-0.061,0.225-0.125,0.376-0.192c0.041-0.642,0.047-1.219,0.047-1.73c0-0.505,0.009-0.977,0.029-1.397\n                c0.02-0.417,0.038-0.829,0.056-1.231c0.023-0.397,0.041-0.802,0.067-1.216c-0.026-1.184-0.067-2.246-0.122-3.192\n                c-0.047-0.925-0.076-1.698-0.076-2.322c-0.843,0.315-1.482,0.566-1.876,0.738c-0.403,0.196-0.7,0.318-0.884,0.408\n                c-0.196,0.088-0.312,0.131-0.356,0.131c-0.055,0-0.134-0.032-0.268-0.094c-0.119-0.052-0.21-0.157-0.228-0.312\n                c-0.041-0.157-0.061-0.318-0.061-0.493c0-0.19,0.021-0.423,0.061-0.671c0.207-0.149,0.426-0.257,0.616-0.368\n                c0.19-0.099,0.397-0.201,0.639-0.315c0.236-0.12,0.531-0.245,0.881-0.394c0.35-0.16,0.793-0.373,1.345-0.671\n                c-0.032-0.983-0.056-1.855-0.067-2.617c-0.023-0.77-0.053-1.5-0.111-2.229c-0.044-0.724-0.105-1.473-0.181-2.267\n                C6.602,9.047,6.503,8.145,6.406,7.13c0-0.119-0.213-0.093-0.674,0.064C5.301,7.363,4.784,7.574,4.209,7.868\n                C3.635,8.172,3.066,8.521,2.512,8.912c-0.551,0.4-0.966,0.791-1.219,1.184c-0.263,0.257-0.426,0.496-0.551,0.721\n                c-0.102,0.222-0.207,0.414-0.28,0.563c-0.082,0.166-0.149,0.248-0.193,0.265C0.225,11.655,0.137,11.57,0,11.357\n                c0.073-0.727,0.303-1.403,0.732-2.045c0.403-0.636,0.922-1.19,1.517-1.698c0.604-0.493,1.275-0.916,1.996-1.272\n                C4.951,5.986,5.642,5.7,6.322,5.484c0.029-0.315,0.029-0.554,0-0.723C6.284,4.589,6.296,4.443,6.354,4.294\n                c0.169-0.029,0.4-0.178,0.727-0.458c0.318-0.254,0.534-0.394,0.665-0.394c0.07,0.178,0.114,0.324,0.143,0.493\n                C7.926,4.087,7.95,4.221,7.979,4.344C8.011,4.481,8.06,4.601,8.087,4.726c0.831-0.432,1.765-0.709,2.815-0.831\n                c1.05-0.137,2.071-0.143,3.028-0.058c0.98,0.111,1.838,0.309,2.588,0.607c0.747,0.295,1.246,0.648,1.499,1.041\n                c0.633,0.761,0.861,1.616,0.671,2.559c-0.195,0.951-0.575,1.864-1.173,2.774c-0.589,0.902-1.287,1.733-2.101,2.483\n                c-0.808,0.773-1.497,1.365-2.077,1.794c0.986-0.172,1.99-0.303,3.008-0.391c1.021-0.07,2.002-0.096,2.944-0.056\n                c0.942,0.05,1.806,0.131,2.599,0.274C22.682,15.074,23.362,15.278,23.896,15.561 M8.224,6.538C8.098,8.314,8.11,9.974,8.276,11.497\n                c0.154,1.526,0.271,3.101,0.335,4.738c0.817-0.309,1.663-0.721,2.532-1.228c0.852-0.519,1.663-1.114,2.433-1.817\n                c0.764-0.715,1.432-1.511,2.007-2.372c0.569-0.872,0.98-1.852,1.243-2.932c0.099-0.522-0.111-0.998-0.598-1.363\n                c-0.487-0.385-1.153-0.648-1.99-0.758c-0.82-0.143-1.765-0.155-2.839-0.032C10.339,5.844,9.28,6.112,8.224,6.538 M9.035,29.652\n                c1.698-0.411,3.442-1.091,5.263-2.025c1.823-0.925,3.457-1.955,4.945-3.066c1.473-1.112,2.658-2.267,3.556-3.434\n                c0.89-1.161,1.263-2.22,1.097-3.154c-0.131-0.621-0.782-1.053-1.981-1.295c-1.199-0.239-2.608-0.327-4.23-0.248\n                c-1.625,0.064-3.273,0.268-4.939,0.607c-1.669,0.341-3.058,0.77-4.134,1.275v2.051c0,0.971,0.006,2.042,0.038,3.194\n                c0.026,1.167,0.088,2.302,0.154,3.44C8.872,28.114,8.936,29.016,9.035,29.652"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "d": "M30.83,27.881c0.729,0.315,1.567-0.175,2.515-1.459c0.931-1.292,1.689-3.358,2.258-6.249\n                c0-0.023,0.111-0.023,0.304,0c0.21,0.029,0.426,0.067,0.654,0.131c0.227,0.058,0.432,0.131,0.624,0.213\n                c0.187,0.073,0.286,0.143,0.286,0.21c0,0.417-0.041,0.931-0.099,1.529c-0.061,0.586-0.137,1.231-0.207,1.952\n                c-0.088,0.706-0.137,1.453-0.172,2.246c-0.035,0.779-0.035,1.572,0,2.369c0.858-0.662,1.78-1.149,2.739-1.494\n                c0.98-0.332,1.902-0.56,2.801-0.639c0.318,0.149,0.487,0.239,0.505,0.283c0.012,0.035-0.061,0.122-0.213,0.231\n                c-1.225,0.309-2.264,0.744-3.183,1.266c-0.902,0.545-1.768,1.135-2.611,1.794c0,0.89,0.017,1.876,0.058,2.911\n                c0.032,1.041,0.053,2.094,0.053,3.136c0,1.047-0.015,2.074-0.029,3.095c-0.017,1.009-0.082,1.923-0.201,2.748\n                c-0.096,0.814-0.263,1.526-0.464,2.095c-0.219,0.58-0.493,0.971-0.843,1.17c-0.254,0.143-0.548,0.228-0.884,0.271\n                c-0.332,0.044-0.677,0.044-1,0.018c-0.335-0.026-0.654-0.094-0.957-0.193c-0.301-0.085-0.546-0.227-0.741-0.397\n                c-0.604-0.542-1.041-1.219-1.286-2.057c-0.254-0.828-0.379-1.742-0.379-2.725c0-0.992,0.125-2.01,0.379-3.051\n                c0.245-1.047,0.592-2.045,1.024-3.011c0.435-0.954,0.948-1.829,1.587-2.605c0.61-0.779,1.286-1.368,2.013-1.786\n                c0.105-1.537,0.146-3.028,0.146-4.493c-0.324,0.729-0.785,1.526-1.377,2.36c-0.607,0.855-1.351,1.514-2.249,1.987\n                c-0.986,0.397-1.826,0.367-2.509-0.12c-0.688-0.478-1.103-1.21-1.269-2.197c-0.154-1.164-0.286-2.121-0.373-2.879\n                c-0.102-0.761-0.184-1.479-0.248-2.17c-0.064-0.674-0.117-1.38-0.16-2.115c-0.056-0.732-0.122-1.648-0.225-2.745\n                c0.169-0.091,0.4-0.108,0.721-0.079c0.315,0.05,0.56,0.143,0.712,0.283c0.102,0,0.166,0.23,0.19,0.677\n                c0.047,0.464,0.076,1.033,0.108,1.742c0.02,0.706,0.079,1.482,0.134,2.302c0.07,0.837,0.178,1.622,0.318,2.372\n                c0.134,0.753,0.341,1.406,0.575,1.96C30.095,27.347,30.404,27.714,30.83,27.881 M35.702,31.437\n                c-0.198,0.196-0.385,0.397-0.604,0.575c-0.201,0.187-0.408,0.391-0.586,0.613c-0.411,0.455-0.817,1.062-1.199,1.826\n                c-0.388,0.758-0.712,1.602-0.98,2.5c-0.277,0.905-0.455,1.815-0.545,2.725c-0.108,0.916-0.085,1.733,0.064,2.459\n                c0.143,0.721,0.438,1.284,0.89,1.692c0.435,0.411,1.065,0.566,1.858,0.49c0.321-0.061,0.572-0.382,0.758-0.974\n                c0.19-0.601,0.335-1.322,0.405-2.188c0.082-0.861,0.123-1.8,0.143-2.827c0.02-1.041,0.012-2.022-0.02-2.982\n                c-0.035-0.931-0.067-1.759-0.123-2.459C35.723,32.172,35.702,31.691,35.702,31.437"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticStyle: {
      "fill": "#0082C3"
    },
    attrs: {
      "points": "130.293,27.589 130.293,21.825 127.078,27.589 "
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#0082C3"
    },
    attrs: {
      "d": "M53.139,0v47.783h191.125V0H53.139z M101.578,36.586H87.663V26.478\n              c-0.4,2.815-1.593,5.225-3.527,7.118c-2.745,2.626-5.143,3.139-8.731,3.139h-9.595V11.302h8.726c4.049,0,6.899,0.528,9.574,3.022\n              c1.926,1.826,3.154,4.3,3.553,7.343V11.182h13.916v5.622h-7.751v4.137h6.721v5.444h-6.721v4.735h7.751V36.586z M136.303,36.586\n              h-6.01v-3.694h-5.849c-0.788,0.82-1.517,1.468-2.197,1.931c-2.188,1.467-4.493,2.217-7.614,2.351c-2.194,0-6.299-0.872-9.691-4.42\n              c-1.966-2.205-3.303-5.257-3.364-9.02c0.093-3.215,0.831-5.4,2.64-7.815c2.958-3.816,6.748-5.409,10.54-5.321\n              c3.939,0.157,6.739,1.505,8.667,3.238c0.738,0.575,1,0.852,1.607,1.485l-3.364,5.902c-0.519-0.756-0.942-1.199-1.639-1.771\n              c0.029,0-2.276-2.442-5.397-2.506c-3.717,0.064-6.491,3.051-6.59,6.788c-0.079,3.763,3.049,7.258,6.716,7.089\n              c3.711-0.248,5.546-3.046,5.724-3.387l9.236-16.255h6.584V36.586z M153.326,17.198h-4.849v19.537h-6.246V17.198h-4.744v-5.896\n              h15.838V17.198z M173.394,36.735h-6.29v-9.723h-6.43v9.723h-6.231V11.302h6.231v9.645h6.43v-9.645h6.29V36.735z M231.562,36.735\n              h-5.467l-9.542-14.175v14.175h-6.272v-8.673c-0.598,1.931-1.639,3.687-3.063,5.155c-2.485,2.588-5.858,3.988-9.42,3.988\n              c-3.343,0-6.272-1.071-8.635-3.145v2.675h-13.502V11.302h6.199v19.817h4.79c-1.319-2.124-2.013-4.577-2.013-7.384\n              c0-3.489,1.348-6.701,3.889-9.184c2.517-2.459,5.668-3.723,9.321-3.723c3.413,0,6.643,1.327,9.125,3.757\n              c1.575,1.549,2.698,3.34,3.308,5.289v-8.574h5.663l9.379,14.123V11.302h6.24V36.735z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#0082C3"
    },
    attrs: {
      "d": "M74.564,31.137h-2.509V16.78h2.48c4.621,0,7.086,2.567,7.086,7.142\n              C81.621,28.943,79.363,31.137,74.564,31.137z"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#0082C3"
    },
    attrs: {
      "d": "M197.797,30.912c-3.533,0-6.716-3.081-6.716-7.078c0-3.725,2.976-6.716,6.789-6.716\n              c3.597,0,6.581,2.99,6.581,6.716C204.452,27.965,201.467,30.912,197.797,30.912z"
    }
  })])])])])])])]), _vm._v(" "), _c('borders', {
    attrs: {
      "show-corners": false,
      "show-text": false,
      "show-dots": false
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showBorders) ? _c('div', {
    staticClass: "mxr-l-borders"
  }, [_c('div', {
    staticClass: "mxr-l-borders--top"
  }, [(_vm.showCorners) ? _c('span', {
    staticClass: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.showCorners) ? _c('span', {
    staticClass: "right"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mxr-l-borders--right",
    class: {
      hasLabel: _vm.nextLabel
    }
  }, [(_vm.nextLabel) ? _c('div', {
    staticClass: "mxr-l-borders__next number",
    on: {
      "click": _vm.getNext
    }
  }, [_vm._v(_vm._s(_vm._f("padToTwo")(_vm.nextLabel)))]) : _vm._e(), _vm._v(" "), (_vm.nextArrow) ? _c('div', {
    staticClass: "mxr-l-borders__next arrow show-for-medium",
    on: {
      "click": _vm.getNextSlider
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-long-arrow-right"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mxr-l-borders--bottom"
  }, [(_vm.showCorners) ? _c('span', {
    staticClass: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.showCorners) ? _c('span', {
    staticClass: "right"
  }) : _vm._e(), _vm._v(" "), (_vm.showGender !== undefined) ? _c('div', {
    staticClass: "mxr-l-borders__title"
  }, [_vm._v("\n      12 outfits\n      "), _c('span', [_vm._v(_vm._s(_vm.genderType))])]) : _vm._e(), _vm._v(" "), (_vm.showChevronDown) ? _c('button', {
    staticClass: "mxr-look__scroll mxr-l-borders__scroll show-for-medium"
  }, [_c('i', {
    staticClass: "zmdi zmdi-long-arrow-down"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mxr-l-borders--left",
    class: {
      hasLabel: _vm.prevLabel
    }
  }, [(_vm.showText) ? _c('div', {
    staticClass: "mxr-l-borders__vtext"
  }, [_vm._v("#DRESSYOURRUN")]) : _vm._e(), _vm._v(" "), (_vm.prevLabel) ? _c('div', {
    staticClass: "mxr-l-borders__prev number",
    on: {
      "click": _vm.getPrev
    }
  }, [_vm._v(_vm._s(_vm._f("padToTwo")(_vm.prevLabel)))]) : _vm._e(), _vm._v(" "), (_vm.prevArrow) ? _c('div', {
    staticClass: "mxr-l-borders__prev arrow show-for-medium",
    on: {
      "click": _vm.getPrevSlider
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-long-arrow-left"
  })]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu mxr-declination"
  }, [(_vm.product && _vm.product.productInfo) ? _vm._l((_vm.product.productInfo.declinations), function(declinaison, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.getProduct(declinaison.modelId)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": ("http://decathlon.fr/" + (declinaison.imgUrl)),
        "alt": "",
        "width": "36"
      }
    })])
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main', {
    attrs: {
      "role": "primary"
    }
  }, [_c('section', {
    staticClass: "home-section section--1 row expanded align-middle align-right",
    style: ({
      height: (_vm.sectionHeight + "px")
    })
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.showVid) ? _c('div', {
    staticClass: "mxr-video"
  }, [_c('div', {
    staticClass: "mxr-video__inner"
  }, [_c('video', {
    staticClass: "v-klnj",
    attrs: {
      "id": "vklnj"
    }
  }, [(_vm.videoSrc) ? _c('source', {
    attrs: {
      "src": _vm.videoSrc,
      "type": _vm.videoType
    }
  }) : _vm._e()])])]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mxr-video-sneak show-for-large",
    on: {
      "click": _vm.createVideo
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Guarda il video")])]), _vm._v(" "), _c('div', {
    staticClass: "light"
  }), _vm._v(" "), _c('div', {
    staticClass: "icon-scroll"
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      height: (_vm.sectionHeight + "px")
    }),
    attrs: {
      "id": "pinContainer"
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "section--hf row expanded align-middle collapse",
    style: ({
      height: (_vm.sectionHeight + "px")
    })
  }, [_c('div', {
    staticClass: "section--women small-12 medium-6 column text-center"
  }, [_c('router-link', {
    staticClass: "section__inner",
    attrs: {
      "to": "/looks/women"
    }
  }, [_c('div', {
    staticClass: "section__title"
  }, [_c('span', [_vm._v("Scopri gli outfits")]), _vm._v(" "), _c('strong', [_vm._v("Donna")])]), _vm._v(" "), _c('div', {
    staticClass: "section__picture section--women__picture"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "section--men small-12 medium-6 column text-center"
  }, [_c('router-link', {
    staticClass: "section__inner",
    attrs: {
      "to": "/looks/men"
    }
  }, [_c('div', {
    staticClass: "section__title"
  }, [_c('span', [_vm._v("Scopri gli outfits")]), _vm._v(" "), _c('strong', [_vm._v("Uomo")])]), _vm._v(" "), _c('div', {
    staticClass: "section__picture section--men__picture"
  })])], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('borders', {
    attrs: {
      "show-corners": !_vm.showVid,
      "show-text": true,
      "show-dots": true
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column shrink mxr-logo__wrap"
  }, [_c('img', {
    staticClass: "mxr-logo",
    attrs: {
      "src": __webpack_require__(434),
      "width": "280",
      "alt": "Mix & Run",
      "id": "mxr-logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mxr-video-sneak__icon"
  }, [_c('i', {
    staticClass: "zmdi zmdi-play"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "storyContainer"
    }
  }, [_c('section', {
    staticClass: "panel panel--freedom"
  }, [_c('div', {
    staticClass: "light"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel__picture"
  }, [_c('div', {
    staticClass: "filter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "word"
  }, [_c('span', [_vm._v("F")]), _vm._v(" "), _c('span', [_vm._v("r")]), _vm._v(" "), _c('span', [_vm._v("e")]), _vm._v(" "), _c('span', [_vm._v("e")]), _vm._v(" "), _c('span', [_vm._v("d")]), _vm._v(" "), _c('span', [_vm._v("o")]), _vm._v(" "), _c('span', [_vm._v("m")])])]), _vm._v(" "), _c('section', {
    staticClass: "panel panel--happiness"
  }, [_c('div', {
    staticClass: "light"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel__picture"
  }, [_c('div', {
    staticClass: "filter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "word"
  }, [_c('span', [_vm._v("H")]), _vm._v(" "), _c('span', [_vm._v("a")]), _vm._v(" "), _c('span', [_vm._v("p")]), _vm._v(" "), _c('span', [_vm._v("p")]), _vm._v(" "), _c('span', [_vm._v("i")]), _vm._v(" "), _c('span', [_vm._v("n")]), _vm._v(" "), _c('span', [_vm._v("e")]), _vm._v(" "), _c('span', [_vm._v("s")]), _vm._v(" "), _c('span', [_vm._v("s")])])]), _vm._v(" "), _c('section', {
    staticClass: "panel panel--achievement"
  }, [_c('div', {
    staticClass: "light"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel__picture"
  }, [_c('div', {
    staticClass: "filter"
  })]), _vm._v(" "), _c('div', {
    staticClass: "word"
  }, [_c('span', [_vm._v("A")]), _vm._v(" "), _c('span', [_vm._v("c")]), _vm._v(" "), _c('span', [_vm._v("h")]), _vm._v(" "), _c('span', [_vm._v("i")]), _vm._v(" "), _c('span', [_vm._v("e")]), _vm._v(" "), _c('span', [_vm._v("v")]), _vm._v(" "), _c('span', [_vm._v("e")]), _vm._v(" "), _c('span', [_vm._v("m")]), _vm._v(" "), _c('span', [_vm._v("e")]), _vm._v(" "), _c('span', [_vm._v("n")]), _vm._v(" "), _c('span', [_vm._v("t")])])])])
}]}

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "mxr-product-item"
  }, [_c('div', {
    staticClass: "mxr-product-item__title"
  }, [_c('div', {
    staticClass: "row align-right"
  }, [_c('div', {
    staticClass: "small-12 medium-8 column"
  }, [_c('div', {
    staticClass: "row align-self-bottom"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [(_vm.variants.length) ? _c('label', [_vm._v("Taglia")]) : _vm._e(), _vm._v(" "), (_vm.selectedColor && _vm.product.productInfo.productId === _vm.selectedColor[1]) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedVariant),
      expression: "selectedVariant"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedVariant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": {}
    }
  }, [_vm._v("Scegli")]), _vm._v(" "), _vm._l((_vm.selectedColor[0].productVariant), function(variant) {
    return _c('option', {
      key: variant.variantId,
      domProps: {
        "value": variant
      }
    }, [_vm._v(_vm._s(variant.description))])
  })], 2)]) : _c('div', [(_vm.product) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedVariant),
      expression: "selectedVariant"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedVariant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": {}
    }
  }, [_vm._v("Scegli")]), _vm._v(" "), _vm._l((_vm.variants), function(variant) {
    return _c('option', {
      key: variant.variantId,
      domProps: {
        "value": variant
      }
    }, [_vm._v(_vm._s(variant.description))])
  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.currentProdPrice))]), _vm._v(" "), _c('div', {
    staticClass: "column shrink align-self-bottom"
  }, [(_vm.variants.length) ? _c('button', {
    staticClass: "button cta-btn",
    attrs: {
      "disabled": !Object.keys(_vm.selectedVariant).length
    },
    on: {
      "click": _vm.submitted
    }
  }, [_vm._v("AGGIUNGI AL CARRELLO")]) : _c('button', {
    staticClass: "button"
  }, [_vm._v("AGGIUNGI AL CARRELLO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-4 column"
  }, [_c('small', {
    staticClass: "product-ref"
  }, [_vm._v("\n          Ref: " + _vm._s(_vm.product.productInfo.productId) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.product.openGraph.title))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 column"
  }, [_c('p', [_c('strong', [_vm._v("Progettato per " + _vm._s(_vm.product.productInfo.productDescription))])])])]), _vm._v(" "), ((_vm.product.productContent.benefsUsers).length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('ul', {
    staticClass: "no-bullet row small-up-1 medium-up-2"
  }, _vm._l((_vm.product.productContent.benefsUsers), function(benef, index) {
    return _c('li', {
      staticClass: "column mxr-benefit"
    }, [_c('div', {
      staticClass: "mxr-benefit__titlewrap"
    }, [_c('span', {
      directives: [{
        name: "colorize",
        rawName: "v-colorize",
        value: (_vm.color),
        expression: "color"
      }],
      staticClass: "mxr-benefit__num"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "mxr-benefit__title"
    }, [_vm._v("\n              " + _vm._s(benef.contentTitle) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "mxr-benefit__content"
    }, [_c('p', [_vm._v(_vm._s(benef.contentValue))])])])
  }))])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mxr-c-nav__cart"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(432)
    }
  }), _vm._v(" "), (_vm.cartSize > 0) ? _c('div', {
    staticClass: "mxr-c-nav__cart__bullet"
  }, [_vm._v(_vm._s(_vm.cartSize))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 461:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mxr-product-item"
  }, [_c('figure', {
    staticClass: "mxr-product-item__figure"
  }, [_c('div', {
    staticClass: "mxr-product-item__img"
  }, [(_vm.selectedColor && _vm.product.productInfo.productId === _vm.selectedColor[1]) ? _c('img', {
    attrs: {
      "src": ("" + (_vm.selectedColor[0].openGraph.image)),
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": ("" + (_vm.product.openGraph.image)),
      "alt": ""
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.cartSize > 0) ? _c('div', {}, [_c('button', {
    staticClass: "mxr-close-btn",
    on: {
      "click": _vm.closeSummary
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })]), _vm._v(" "), _c('table', {
    staticClass: "unstriped stack"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.cart), function(product, index) {
    return _c('tr', [_c('td', {
      staticClass: "align-small-pic"
    }, [_c('img', {
      attrs: {
        "src": product.image,
        "alt": "",
        "width": "50"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "align-small-name"
    }, [_c('div', {
      staticClass: "mxr-product__title"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('div', [_vm._v("Taglia " + _vm._s(product.size))])]), _vm._v(" "), _c('td', {
      staticClass: "align-small-price"
    }, [_c('span', {
      staticClass: "price-label hide-for-large"
    }, [_vm._v("Prezzo : ")]), _vm._v(" " + _vm._s(product.price) + " €")]), _vm._v(" "), _c('td', {
      staticClass: "align-small-qty text-center"
    }, [_c('button', {
      staticClass: "button-qty",
      on: {
        "click": function($event) {
          _vm.decrement(index)
        }
      }
    }, [_c('i', {
      staticClass: "zmdi zmdi-minus"
    })]), _vm._v("\n          " + _vm._s(product.quantity) + "\n          "), _c('button', {
      staticClass: "button-qty",
      on: {
        "click": function($event) {
          _vm.increment(index)
        }
      }
    }, [_c('i', {
      staticClass: "zmdi zmdi-plus"
    })])]), _vm._v(" "), _c('td', {
      staticClass: "align-small-total"
    }, [_c('span', {
      staticClass: "price-label hide-for-large"
    }, [_vm._v("Total : ")]), _vm._v(_vm._s((product.price * product.quantity).toFixed(2)) + " €")])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Totale")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total) + " €")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "cart-nav"
  }, [_c('a', {
    staticClass: "button cta-btn",
    attrs: {
      "href": _vm.exportURL
    }
  }, [_vm._v("Continua su Decathlon.it")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "80"
    }
  }), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Prezzo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Quantità")]), _vm._v(" "), _c('th', [_vm._v("Totale")])])])
}]}

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sum"
  }, [(_vm.active && _vm.cartSize > 0) ? _c('div', {
    staticClass: "mxr-cart-summary__backdrop"
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.active) ? _c('cart-summary', {
    staticClass: "mxr-cart-summary",
    nativeOn: {
      "mouseleave": function($event) {
        _vm.hideSummary($event)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mxr-c-nav row expanded collapse align-middle align-justify"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('router-link', {
    staticClass: "mxr-c-nav__logo",
    attrs: {
      "to": "/home"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(433)
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('ul', {
    staticClass: "mxr-c-nav__menu menu horizontal align-center mxr-c-nav__menu--hascart"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/looks/women"
    }
  }, [_vm._v("Donna")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/looks/men"
    }
  }, [_vm._v("Uomo")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "show-summary-btn",
    on: {
      "click": _vm.showSummary
    }
  }, [(_vm.showCart) ? _c('cart') : _vm._e()], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(151);
__webpack_require__(152);
module.exports = __webpack_require__(150);


/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var utils = {};
var rootPath =  true ? 'http://35.189.238.119' : 'http://' + location.hostname + ':3000';
var headers = {
  'x-goog-project-id': 144043847891
};
/**
 * Fetch a product from Decathlon's API
 * @param  {String}    ref       One reference like '123456'
 * @param  {Function}  callback
 */
utils.fetchProduct = function (ref, callback) {
  var inputJSON = { productId: '' + ref, productLocale: 'it_IT' };
  var serverURL =  true ? rootPath + '/?serviceName=WSGetProductInfo&inputJSON={"productId":"' + ref + '","productLocale":"it_IT"}' : rootPath + '/?serviceName=WSGetProductInfo&inputJSON=' + encodeURIComponent(_JSON$stringify(inputJSON));
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    method: 'get',
    url: serverURL,
    headers: headers
  }).then(function (response) {
    var datas = response.data.outputJSON[0].productInfo;
    callback(datas);
  }).catch(function (e) {
    callback(null);
    console.log(e);
  });
};

/**
 * Fetch an array of products from Decathlon's API
 * @param  {Array}    refs     Array of references like ['123456', '987654']
 * @param  {Function} callback
 */
utils.fetchAllProducts = function (refs, callback) {
  var found = 0;
  var array = [];
  var productsReturn = function productsReturn(datas) {
    window.vm.$Progress.start();
    found += 1;
    if (datas != null && datas.productVariant.length && datas.openGraph.image.slice(-1) !== '_') {
      array.push(datas);
    }
    if (found === refs.length) {
      callback(array);
      window.vm.$Progress.finish();
    }
  };
  refs.forEach(function (ref) {
    return utils.fetchProduct(ref, productsReturn);
  });
};

utils.getBorderedViewport = function () {
  var height = 0;
  var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  var borderTop = document.getElementsByClassName('mxr-l-borders--top');
  var borderBottom = document.getElementsByClassName('mxr-l-borders--bottom');
  var navigationBottom = document.getElementsByClassName('mxr-c-nav');

  height = borderTop[0].offsetHeight + borderBottom[0].offsetHeight + navigationBottom[0].offsetHeight;
  height = viewportHeight - height;
  return height;
};

utils.outerHeight = function (el) {
  var height = el.offsetHeight;
  var style = getComputedStyle(el);
  height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
  return height;
};

utils.isTouchDevice = function () {
  return 'ontouchstart' in document.documentElement;
};

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var Component = __webpack_require__(16)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(455),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3dfeed11",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[469]);


// WEBPACK FOOTER //
// static/js/app.ef9bc9e793221a082ec1.js